import {Styles, GenerateClassName} from '../hocs/inject-sheet'
import cn from 'classnames'
import {mapValues} from 'lodash-es'

type AnimationNameGenerator = (name: string) => string

export const generateClassName: GenerateClassName<{key: string}> = (rule, sheet) => {
  const customComponentName = sheet!.options.componentName
  if (!customComponentName) {
    throw new Error(
      `Component name for ${sheet!.options.classNamePrefix} not implemented! Make sure you use custom jss injectSheet hoc.`
    )
  }
  return `${customComponentName}_${rule.key}`
}

const createGenerateAnimationNameDev = (): AnimationNameGenerator => {
  let counter = 0
  return (name) => `${name}-${counter++}`
}

const createGenerateAnimationNameProduction = (): AnimationNameGenerator => {
  let counter = 0
  return () => `_${(counter++).toString(36)}`
}

/**
 * Генерирует имя для CSS Keyframes Animation
 */
export const generateAnimationName = process.env.NODE_ENV === 'production'
                                  ? createGenerateAnimationNameProduction()
                                  : createGenerateAnimationNameDev()

/**
 * Маленькая DSL функция, помогающая выводить имена классов из объекта стилей
 */
export const createStyles = <Name extends string>(
  styles: Styles<Name>
): Styles<Name> => (
  styles
)

/**
 * Объединяет сгенерированные имена классов из двух объектов.
 *
 * @example
 *
 * const classes = { root: '_1' }
 * const customClasses = { root: 'my-custom-classname' }
 *
 * mergeClasses(classes, customClasses) // => { root: '_1 my-custom-classname' }
 */
export const mergeClasses = <T extends Record<string, string>>(classes: T, customClasses: Partial<T>): Record<keyof T, string> => (
  mapValues<T, any>(classes, (val, key) => cn(val, customClasses[key]))
)
